import { postLog } from '@/api/log.api'

export const CREATE_LOG = 'CREATE_LOG'
export const CREATE_LOG_LOADING = 'CREATE_LOG_LOADING'
export const CREATE_LOG_DONE = 'CREATE_LOG_DONE'
export const CREATE_LOG_ERROR = 'CREATE_LOG_ERROR'

export default {
  [CREATE_LOG] (context, payload) {
    context.commit(CREATE_LOG_LOADING)
    return postLog(payload)
      .then((response) => {
        context.commit(CREATE_LOG_DONE, response)
      })
      .catch((error) => {
        context.commit(CREATE_LOG_ERROR, error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/log/actions.js